import { createLogger } from "browser-bunyan";
type Logger = ReturnType<typeof createLogger>;

const url = process.env.REACT_APP_API_BYGGDATA_BASE_URL + "api/nobb/import";

export interface IMigrations {
    applied: string[],
    pending: string[]
}

export default class Item {
    private fetch: ((input: string, init?: RequestInit) => Promise<Response>);
    private log?: Logger;

    constructor(
        f: ((input: string, init?: RequestInit) => Promise<Response>),
        l?: Logger
    ) {
        this.fetch = f;
        this.log = l;
    }

    public reinit = () => this.fetch(url + "/reinit", { method: "post" });

    public migrate = () => this.fetch(url + "/migrate", { method: "post" });

    public migrations = () => this.fetch(url + "/migrations")
        .then(r => r.json() as Promise<IMigrations>)
        .catch(r => {
            if (this.log) {
                this.log.error(r);
            }
        });
}


// WEBPACK FOOTER //
// ./src/data/database.ts